import style from "./JobDescription.module.css";
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import JobPostCard from "../../components/JobPostCard";
import { getJobDetail } from "../../api/containersApi";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { jobIDIcon, jobExperienceIcon, jobLocationIcon, jobLevelIcon, hyperLink, applyJob, linkedInIcon, linkedinIcon, whatsapIcon, twitterIcon, emailIcon, XIcon } from "../../assets";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import JobShare from "../../components/JobShare";

export default function JobDescription() {
    
    const { jobId } = useParams();
    const navigate = useNavigate(); 
    
    const {data: jobDetail, isLoading, isFetching, error, refetch} = useQuery({
        queryKey: ["jobDescription"],
        queryFn: () => getJobDetail({auth_key: localStorage.getItem("sessionToken"), jobId: jobId, preview: 1}),
        keepPreviousData: true,
        staleTime: 1000
    });

    useEffect(() => {
        refetch();
    }, [ jobId ])

    return(
        <div className={style.jobDescription_container}>

            <HeaderMobile />

            <div className={style.jobDescription_dashboard}>
                
                <Header />

                <div className={style.jobDescription_dashboard_header}>
                    <p style={{ fontSize: "32px", fontWeight: "bold", margin: "0px"}}>
                        {jobDetail?.jobTitle}
                        <br />
                        <span style={{ fontSize: "14px", fontWeight: "medium", color: "white", backgroundColor: "#0BA02C", padding: "0.5rem 1rem", borderRadius: "3px"}}>
                            {jobDetail?.jobType.toUpperCase()}
                        </span>
                    </p>
                    {/* <button onClick={() => navigate("/apply-job", { state: { jobId: jobId } })} className={style.jobDescription_dashboard_header_button}> */}
                    {/* <button onClick={() => navigate("/jobs/job-description/:jobId/apply")}> */}
                    <button onClick={() => {navigate('apply', { state: {jobTitle: jobDetail?.jobTitle, jobId: jobDetail?.jobId} })}}>
                        Apply Now &nbsp;
                        <img src={applyJob} alt="->" />
                    </button>
                </div>

                <div className={style.jobDescription_dashboard_content}>
                    <section
                        id="throwHTML"
                        className={style.jobDescription_dashboard_content_description}
                        dangerouslySetInnerHTML={{ __html: jobDetail?.jobDescription || "<p>No job description available</p>" }}
                    />
                    <aside className={style.jobDescription_dashboard_content_aside}>
                        <div className={style.jobDescription_dashboard_content_aside_jobOverview}>
                            <p>Job Overview</p>
                            <div className={style.jobOverview_card_container}>
                                <div className={style.jobOverview_card}>
                                    <img src={jobLocationIcon} alt="job location" />
                                    <p>JOB LOCATION</p>
                                    <p>
                                        {
                                            jobDetail?.city === jobDetail?.state ? jobDetail?.city : jobDetail?.city + ", " + jobDetail?.state
                                        }
                                    </p>
                                </div>
                                <div className={style.jobOverview_card}>
                                    <img src={jobLevelIcon} alt="job level" />
                                    <p>JOB LEVEL</p>
                                    <p>{jobDetail?.jobType}</p>
                                </div>
                                <div className={style.jobOverview_card}>
                                    <img src={jobExperienceIcon} alt="experience" />
                                    <p>EXPERIENCE</p>
                                    <p>{jobDetail?.expFrom}-{jobDetail?.expTo} Years</p>
                                </div>
                                <div className={style.jobOverview_card}>
                                    <img src={jobIDIcon} alt="job id" />
                                    <p>JOB ID</p>
                                    <p>{jobDetail?.jobId}</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className={style.shareThisJob_container}>
                            <p>Share this job:</p>
                            <JobShare />
                        </div>
                    </aside>
                </div>

                <div className={style.mobileViewApplyButton}>
                    <button onClick={() => {navigate('apply', { state: {jobTitle: jobDetail?.jobTitle, jobId: jobDetail?.jobId} })}}>
                        Apply Now &nbsp;
                        <img src={applyJob} alt="->" />
                    </button>
                </div>

            </div>

            {   
                jobDetail?.relatedJobs?.length !== 0 && 
                <div className={style.relatedJobs_container}>
                    <p>Related Jobs</p>
                    <section>
                        {
                            jobDetail?.relatedJobs?.map((job, index) => {
                                return <JobPostCard to={`/jobs/job-description/${job?.jobId}`} jobTitle={job?.jobTitle} jobType={job?.jobType} location={job?.location} />
                            })
                        }
                    </section>
                </div>                               
            }
        </div>
    );
}